<template>
    <div class="com-sgp-left text-white">
        <div>
            <BlockBox title="评价占比" enTitle="Evaluation Proportion" height="296">
                <template #content>
                    <div class="proportionHeader">
                        <div class="proportionFilter">
                            <el-select v-model="filterScope" size="mini" style="width:160px;" popper-append-to-body>
                                <el-option label="全部" value="all"></el-option>
<!--                                <el-option label="六个一指标体系" value="six"></el-option>-->
<!--                                <el-option label="五育童真好少年" value="wuyu"></el-option>-->
                            </el-select>
                        </div>
                        <div class="proportionTabs">
                            <span class="tabText">本周新增</span>
                        </div>
                    </div>
                    <div class="proportionWrap">
                        <div class="proportionChart">
                            <div id="chartProportion" style="width:100%;height:100%;"></div>
                        </div>
                        <div class="proportionInfo">
                            <div class="totalScore">
                                <div class="scoreNum">{{item.goodCount+item.badCount}}</div>
                                <div class="scoreLabel">累计总分</div>
                            </div>
                            <div class="scoreDetail">
                                <div class="scoreRow">
                                    <span class="label">表扬（分）</span>
                                    <span class="value text-color-green">+{{item.goodCount||'0'}} 分</span>
                                    <!-- <span class="rate">{{praiseRate}}%</span> -->
                                </div>
                                <div class="scoreRow">
                                    <span class="label">改正（分）</span>
                                    <span class="value text-color-red">- {{item.badCount||'0'}} 分</span>
                                    <!-- <span class="rate">{{correctRate}}%</span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </BlockBox>
        </div>
        
        <div class="margin-top-15">
            <BlockBox title="评价趋势" enTitle="Evaluation Trend" height="295">
                <template #content>
                    <div class="trendFilter">
                        <el-select v-model="trendScope" size="mini" style="width:160px;" popper-append-to-body>
                            <el-option label="全部" value="all"></el-option>
<!--                            <el-option label="六个一指标体系" value="six"></el-option>-->
<!--                            <el-option label="五育童真好少年" value="wuyu"></el-option>-->
                        </el-select>
                    </div>
                    <div style="padding:10px 15px;box-sizing: border-box">
                        <div id="chartTrend" style="height:250px;"></div>
                    </div>
                </template>
            </BlockBox>
        </div>
        
        <div class="margin-top-15">
            <BlockBox title="评价排行榜" enTitle="Evaluation Ranking" height="359">
                <template #content>
                    <div class="leftFilter">
                        <el-select v-model="rankType" size="mini" style="width:80px;" popper-append-to-body>
                            <el-option label="本学年" value="year"></el-option>
                            <el-option label="本学期" value="term"></el-option>
                        </el-select>
                    </div>
                    <div style="padding:10px 15px;box-sizing: border-box">
                        <div id="chartRank" style="height:320px;"></div>
                    </div>
                </template>
            </BlockBox>
        </div>
    </div>
</template>

<script>
    import * as echarts from 'echarts';
    import echartMixins from "@/utils/resizeMixins";
    import BlockBox from '@/views/components/blockBox'
    import { leftDataSchool } from "@/api/api";
    
    export default {
        name: "sgpLeftContent",
        components: {
            BlockBox
        },
        mixins: [echartMixins],
        data() {
            return {
              schoolId:"",
                item:"",
                filterScope: 'all',
                trendScope: 'all',
                rankType: 'year',
                totalScore: 6247,
                praiseScore: 69,
                correctScore: 0,
                praiseRate: 100.0,
                correctRate: 0.0,
                trendData: {
                    dates: ['10月', '11月', '12月', '1月', '2月', '3月', '4月', '5月', '9月'],
                  activityList: [800, 1200, 1500, 400, 300, 600, 500, 400, 1400],
                  activityTaskList: [600, 900, 1100, 300, 200, 400, 350, 300, 1000]
                },
                rankData: {
                    grades: ['1年级', '2年级', '3年级', '4年级', '5年级', '6年级'],
                    oneList: [1200, 1500, 1800, 800, 1600, 1400],
                    twoList: [300, 400, 500, 200, 450, 350],
                    threeList: [500, 600, 800, 300, 700, 600]
                },
                timerLeft: null,
            }
        },
        mounted() {

        },
        beforeDestroy() {
            clearTimeout(this.timerLeft);
        },
        watch: {
            filterScope() {
                this.$nextTick(() => {
                    this.drawProportion();
                });
            },
            trendScope() {
                this.$nextTick(() => {
                    this.drawTrend();
                });
            },
            rankType() {
                this.$nextTick(() => {
                    this.drawRank();
                });
            }
        },
        methods: {
            init(schoolId){
              this.schoolId=schoolId;
              this.changeData();
              console.log("lefc:"+this.schoolId);
              this.timerLeft = setTimeout(() => {
                this.changeData();
              }, 60000);
            },
            async changeData() {
                try {
                    const res = await leftDataSchool(this.schoolId);
                    if (res && res.data) {
                      this.item=res.data;
                      if (res.data.activityList) {
                        let activityList= res.data.activityList;
                        let activityTaskList= res.data.activityTaskList;
                        let dates=[];
                        let activityListCount=[];
                        let activityTaskListCount=[];
                        activityList.forEach(obj=>{
                          dates.push(obj.name);
                          activityListCount.push(obj.value);
                        })
                        activityTaskList.forEach(obj=>{
                          activityTaskListCount.push(obj.value);
                        })
                        this.trendData={
                          dates: dates,
                          activityList:activityListCount,
                          activityTaskList: activityTaskListCount
                        }
                      }

                      if (res.data.gradeList) {
                        let gradeList= res.data.gradeList;
                        let grades=[];
                        let oneList=[];
                        let twoList=[];
                        let threeList=[];
                        gradeList.forEach(obj=>{
                          grades.push(obj.gradeName);
                          oneList.push(obj.count1);
                          twoList.push(obj.count2);
                          threeList.push(obj.count3);
                        })

                        this.rankData={
                          grades: grades,
                          oneList:oneList,
                          twoList: twoList,
                          threeList:threeList
                        }
                      }
                    }
                } catch (e) {
                    console.log('使用默认数据');
                }
                this.$nextTick(() => {
                    this.drawProportion();
                    this.drawTrend();
                    this.drawRank();
                });
            },
            drawProportion() {
				console.log(echarts)
                this.chart1 = this.$echarts.init(document.getElementById("chartProportion"));
                let option = {
                    series: [{
                        type: 'pie',
                        radius: ['55%', '75%'],
                        center: ['50%', '50%'],
                        startAngle: 90,
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 5,
                            borderColor: '#0a1a3a',
                            borderWidth: 2
                        },
                        label: {
                            show: false
                        },
                        data: [
                            { value: this.praiseScore, name: '表扬', itemStyle: { color: '#67e591' } },
                            { value: this.correctScore, name: '改正', itemStyle: { color: '#f0792a' } },
                            { value: Math.max(100 - this.praiseScore - this.correctScore, 0), name: '其他', itemStyle: { color: 'rgba(100,180,255,0.2)' } }
                        ]
                    }]
                };
                this.chart1.setOption(option);
                window.addEventListener("resize", () => {
                    this.chart1.resize();
                });
            },
            drawTrend() {
                this.chart2 = this.$echarts.init(document.getElementById("chartTrend"));
                console.log("dates:"+JSON.stringify(this.trendData.dates));
              console.log("activityTaskList:"+JSON.stringify(this.trendData.activityTaskList));
              console.log("activityList:"+JSON.stringify(this.trendData.activityList));
                let option = {
                    grid: {
                        left: '3%',
                        right: '3%',
                        bottom: '15%',
                        top: 10,
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['活动任务数', '点评人数'],
                        textStyle: {
                            color: 'rgba(255,255,255,0.7)',
                            fontSize: 10
                        },
                        top: 0,
                        right: 0,
                        itemWidth: 10,
                        itemHeight: 6
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: this.trendData.dates,
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(255,255,255,0.6)',
                                fontSize: 10
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(100,180,255,0.3)'
                            }
                        },
                        splitLine: {
                            show: false
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(255,255,255,0.6)',
                                fontSize: 10
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: 'rgba(100,180,255,0.1)'
                            }
                        },
                        axisLine: {
                            show: false
                        }
                    },
                    series: [{
                        name: '活动任务数',
                        type: 'line',
                        smooth: true,
                        data: this.trendData.activityTaskList,
                        lineStyle: { color: '#03DBF4', width: 2 },
                        itemStyle: { color: '#03DBF4' },
                        symbol: 'circle',
                        symbolSize: 4
                    }, {
                        name: '点评人数',
                        type: 'line',
                        smooth: true,
                        data: this.trendData.activityList,
                        lineStyle: { color: '#f7cc08', width: 2 },
                        itemStyle: { color: '#f7cc08' },
                        symbol: 'circle',
                        symbolSize: 4
                    }]
                };
                this.chart2.setOption(option);
                window.addEventListener("resize", () => {
                    this.chart2.resize();
                });
            },
            drawRank() {
                this.chart3 = this.$echarts.init(document.getElementById("chartRank"));
                let option = {
                    grid: {
                        left: '3%',
                        right: '3%',
                        bottom: '15%',
                        top: 10,
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { type: 'shadow' }
                    },
                    legend: {
                        data: ['表扬类评价数', '改正类评价数', '采集类评价数'],
                        textStyle: {
                            color: 'rgba(255,255,255,0.7)',
                            fontSize: 10
                        },
                        top: 0,
                        right: 0,
                        itemWidth: 10,
                        itemHeight: 6
                    },
                    xAxis: {
                        type: 'category',
                        data: this.rankData.grades,
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(255,255,255,0.6)',
                                fontSize: 10
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(100,180,255,0.3)'
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(255,255,255,0.6)',
                                fontSize: 10
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: 'rgba(100,180,255,0.1)'
                            }
                        },
                        axisLine: {
                            show: false
                        }
                    },
                    series: [{
                        name: '表扬类评价数',
                        type: 'bar',
                        stack: 'total',
                        data: this.rankData.oneList,
                        itemStyle: { color: '#67e591' },
                        barWidth: 20
                    }, {
                        name: '改正类评价数',
                        type: 'bar',
                        stack: 'total',
                        data: this.rankData.twoList,
                        itemStyle: { color: '#f7cc08' },
                        barWidth: 20
                    }, {
                        name: '采集类评价数',
                        type: 'bar',
                        stack: 'total',
                        data: this.rankData.threeList,
                        itemStyle: { color: '#03DBF4' },
                        barWidth: 20
                    }]
                };
                this.chart3.setOption(option);
                window.addEventListener("resize", () => {
                    this.chart3.resize();
                });
            }
        }
    }
</script>

<style lang="scss">
    .com-sgp-left {
        min-height: 500px;
        padding: 14px 15px 15px 15px;
        box-sizing: border-box;

        .proportionHeader {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 15px 0;
            box-sizing: border-box;

            .proportionFilter {
                display: flex;
                align-items: center;
            }

            .proportionTabs {
                display: flex;
                align-items: center;
                gap: 15px;

                .tabText {
                    font-size: 16px;
                    color: #fff;
                    font-weight: bold;
                }
            }
        }

        .trendFilter {
            display: flex;
            align-items: center;
            padding: 10px 15px 0;
            box-sizing: border-box;
        }

        .proportionWrap {
            display: flex;
            align-items: center;
            padding: 0 15px;
            box-sizing: border-box;
			margin-top: 20px;

            .proportionChart {
                width: 180px;
                height:220px;
                flex-shrink: 0;
            }

            .proportionInfo {
                flex: 1;
                padding-left: 10px;

                .totalScore {
                    text-align: center;
                    margin-bottom: 10px;

                    .scoreNum {
                        font-size: 28px;
                        font-weight: bold;
                        color: #fff;
                    }

                    .scoreLabel {
                        font-size: 12px;
                        color: rgba(255, 255, 255, 0.6);
						margin-top: 15px;
                    }
                }

                .scoreDetail {
					border-top:1px dashed rgba(255, 255, 255, 0.2);
                    .scoreRow {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        font-size: 14px;
                     
						border-bottom:1px dashed rgba(255, 255, 255, 0.2);
						padding: 15px 0;

                        .label {
                            color: rgba(255, 255, 255, 0.7);
                        }

                        .value {
                            font-weight: bold;
							font-size:20px;
                        }

                        .rate {
                            color: rgba(255, 255, 255, 0.5);
                            font-size: 11px;
                        }
                    }
                }
            }
        }
    }

    .leftFilter {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 10px;
        padding: 10px 15px 0;
        box-sizing: border-box;
    }
</style>
